<template>
	<v-container class="pa-0">
		<v-dialog width="500px" v-model="showEditGroup">
			<v-card>
				<v-card-title><v-icon>mdi-pencil</v-icon> Editar Grupo</v-card-title>
				<v-card-text>
					<v-img v-if="grupo.imagem_grupo" width="100px" contain height="auto" class="mx-auto rounded-sm"
						:src="`https://api.mylegis.com.br/assets/${grupo.imagem_grupo}`" />
					<h3><v-icon small>mdi-pencil</v-icon> Nome do Grupo</h3>
					<v-text-field :color="dynamicColor" v-model="edit.nome_grupo"></v-text-field>

					<h3><v-icon small>mdi-image</v-icon> Imagem</h3>

					<v-file-input :color="dynamicColor" v-model="edit.imagem_grupo" label="Alterar Imagem"></v-file-input>

					<h3 v-if="user.plano === `plano-premium`">
						<v-icon small>mdi-lock</v-icon> Restrito
					</h3>
					<v-checkbox v-if="user.plano === `plano-premium`" :color="dynamicColor" v-model="edit.restrito"
						label="Grupo Restrito (participantes não podem exportar conteúdos do grupo)" />
				</v-card-text>
				<v-card-actions class="d-flex justify-end">
					<v-btn text @click="showEditGroup = false">
						Cancelar</v-btn>
					<v-btn :#loading="loadingEdit" :color="dynamicColor" dark @click="updateGroup">
						<v-icon>mdi-check</v-icon>
						Salvar Grupo</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog width="500px" v-model="showGroupDetails">
			<v-card>
				<v-card-title class="d-flex align-center">
					<v-icon class="mr-2">mdi-information</v-icon>
					Detalhes do Grupo
					<v-spacer></v-spacer>
					<v-btn @click="showGroupDetails = false" text>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" class="text-center">
							<v-img v-if="grupo.imagem_grupo" width="150px" contain height="auto" class="mx-auto rounded-sm mb-4"
								:src="`https://api.mylegis.com.br/assets/${grupo.imagem_grupo}`" />
						</v-col>
						<v-col cols="12">
							<h3 class="mb-2">Nome do Grupo</h3>
							<p class="text-h6">{{ grupo.nome_grupo }}</p>
						</v-col>
						<v-col cols="12">
							<h3 class="mb-2">Criado por</h3>
							<p>{{ grupo.user_created }}</p>
						</v-col>
						<v-col cols="12">
							<h3 class="mb-2">Total de Integrantes</h3>
							<p>{{ grupo.integrantes ? grupo.integrantes.length : 0 }}</p>
						</v-col>
						<v-col cols="12">
							<h3 class="mb-2">Administradores</h3>
							<p>{{ grupo.administradores ? grupo.administradores.length : 0 }}</p>
						</v-col>
						<v-col cols="12" v-if="grupo.restrito">
							<v-alert type="info" dense>
								Este é um grupo restrito. Os participantes não podem exportar conteúdos.
							</v-alert>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="justify-end">
					<v-btn text @click="showGroupDetails = false">Fechar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row class="mt-3">
			<v-col class="text-center" cols="12" lg="3" order="1" order-lg="2">
				<DialogConfirm :titulo="`${isOwner ? `Excluir` : `Sair do`} Grupo`" icon="mdi-delete-outline" :texto="`Você tem certeza que deseja ${isOwner ? `excluir o` : `sair do`
					} grupo ${grupo.nome_grupo}`" :botao="`${isOwner ? `Excluir` : `Sair do`} Grupo`" :confirmado="excluirGrupo">
				</DialogConfirm>
				<BtnAdicionarGrupo class="mt-2" v-if="isAdmin" :reload-integrantes="reloadGrupo" :id-grupo="grupo.id"
					:integrantes="grupo.integrantes"></BtnAdicionarGrupo>
				<v-expansion-panels flat   accordion open-on-hover elevation="1" class="mt-2">
					<v-expansion-panel>
						<v-expansion-panel-header>
							<h2 class="text-center" :style="{ color: dynamicColor }">Administradores</h2>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-list style="width: 100%">
								<v-list-item v-for="a in grupo.administradores" :key="a.directus_users_id.id">
									<v-list-item-avatar>
										<v-img max-width="40px" height="40px" class="rounded-circle" cover :src="a.directus_users_id.avatar
												? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}`
												: require(`../assets/icon-person.svg`)
										" />
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="d-flex text-subtitle-2" style="white-space: inherit">
											<router-link :to="`/painel/u/${a.directus_users_id.id}/${sanitizeTitle(
												a.directus_users_id.first_name
											)}`" class="">
												{{ a.directus_users_id.first_name }}
												{{
													a.directus_users_id.last_name !== null
														? a.directus_users_id.last_name
														: ''
											}}
										</router-link>
									</v-list-item-title>
									<v-list-item-subtitle>
										<v-btn disabled x-small class="d-flex justify-start text-left" outlined
											v-if="isOwner & (user.id == a.directus_users_id.id)">
											Proprietário
										</v-btn>
										<v-btn v-if="isOwner && user.id !== a.directus_users_id.id"
											@click="excluirAdmin(a.id)" class="pa-0" text x-small
											style="cursor: pointer">
											<v-icon small>mdi-close</v-icon> Remover Administrador
										</v-btn>
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-expansion-panel-content>
					</v-expansion-panel>
					<v-expansion-panel>
						<v-expansion-panel-header>
							<h2 class="text-center" :style="{ color: dynamicColor }">Integrantes</h2>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-list>
								<v-hover v-slot="{ hover }" v-for="a in integrantes" :key="a.directus_users_id.id"
									v-show="!isInAdmin(a.directus_users_id.id)">
									<v-list-item>
										<v-list-item-avatar>
											<v-img max-width="40px" height="40px" class="rounded-circle" cover :src="a.directus_users_id.avatar
													? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}`
													: require(`@/assets/icon-person.svg`)
											" />
										</v-list-item-avatar>
										<v-list-item-content class="d-flex flex-row">
											<v-list-item-title class="d-flex text-subtitle-2" style="white-space: inherit">
												<router-link :to="`/painel/u/${a.directus_users_id.id
													}/${sanitizeTitle(a.directus_users_id.first_name)}`" class="">
													{{ a.directus_users_id.first_name }}
													{{
														a.directus_users_id.last_name !== null
															? a.directus_users_id.last_name
															: ''
													}}
												</router-link>
											</v-list-item-title>
											<v-list-item-subtitle v-if="isAdmin && hover"
												@click="tornarAdmin(a.directus_users_id.id)">
												<v-btn x-small>
													<v-icon small>mdi-account-star-outline</v-icon>Tornar
													Administrador
												</v-btn>
											</v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-icon v-if="isAdmin" small
												@click="excluirIntegrante(a.id)">mdi-delete</v-icon><br />
										</v-list-item-action>
									</v-list-item>
								</v-hover>
							</v-list>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-col>
			<v-col class="mt-0 pt-0 d-flex flex-column justify-space-between" cols="12" lg="9" order="2" order-lg="1">
				<h3 class="d-flex flex-row align-center justify-space-between my-orange mt-3 mb-10">
					<div :color="dynamicColor">
						<v-img v-if="grupo.imagem_grupo" width="100px" contain height="auto" class="rounded-sm mr-5"
							:src="`https://api.mylegis.com.br/assets/${grupo.imagem_grupo}`" />
						<p :style="{ color: dynamicColor }"> {{ grupo.nome_grupo }}</p>
						<div class="d-flex">
							<v-btn outlined x-small class="ml-5" v-if="isOwner" @click="
								edit.nome_grupo = grupo.nome_grupo;
								showEditGroup = true;
							">
								<v-icon small>mdi-pencil</v-icon>Editar
							</v-btn>
							<v-btn outlined x-small class="ml-2" @click="showGroupDetails = true">
								<v-icon small>mdi-information</v-icon>Detalhes
							</v-btn>
						</div>
					</div>
					<v-btn text @click="reloadGrupo"><v-icon color="black">mdi-refresh</v-icon> Atualizar</v-btn>
				</h3>
				<v-row>
					<v-col cols="12">
						<v-tabs
						bg-color="indigo-darken-2"
						fixed-tabs
						v-model="active"
						:color="dynamicColor"
					>
						<v-tab  value="feed">
							<v-icon  class="mr-2">mdi-rss</v-icon>Feed do Grupo
						</v-tab>
						<v-tab  :to="`/painel/grupo/${grupo.id}/arquivos`" value="files">
							<v-icon class="mr-2">mdi-folder</v-icon>Arquivos do Grupo
						</v-tab>
					</v-tabs>
					
					</v-col>
					<v-col cols="12">
					<h2 :style="{ color: dynamicColor }">Feed do Grupo</h2>
					<v-btn v-if="isAdmin"  color="#F15A24" dark class="mb-4" @click="showNewAnnotation = true">
						<v-icon left>mdi-plus</v-icon>
						Nova Anotação
					</v-btn>
				</v-col>
					<v-col v-if="anotacoes.length == 0 && anotacoesProjetos.length == 0 && !loadingFeed" cols="12">
						<p class="mt-5">
							Ainda não existe conteúdo por aqui. Faça anotações e conexões para
							alimentar o seu feed.
						</p>
					</v-col>
					<v-col cols="12" class="text-center">
						<v-progress-circular v-if="loadingFeed" class="mx-auto" :color="dynamicColor"
							indeterminate></v-progress-circular>
					</v-col>
					<div style="width: 100%" v-if="!loadingFeed">
						<v-col v-for="(annotation, i) in anotacoes" :key="i" cols="12">
							<annotation :annotation="annotation"></annotation>
						</v-col>

						<v-col v-for="(annotation, i) in anotacoesProjetos" :key="i" cols="12">
							<AnnotationProjetolei :annotation="annotation"></AnnotationProjetolei>
						</v-col>
					</div>
				</v-row>
			</v-col>
		</v-row>
		<v-dialog width="800px" v-model="showNewAnnotation">
			<v-card class="px-5">
				<v-card-title  v-if="isAdmin" class="px-0">Nova Anotação <v-spacer />
					<v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-card-text>
					<h3>Conteúdo</h3>
					<div class="d-flex">
						<v-spacer></v-spacer>
						<v-btn text small @click="undo"><v-icon>mdi-undo</v-icon> Desfazer</v-btn>
						<v-btn @click="redo" text small><v-icon>mdi-redo</v-icon> Refazer</v-btn>
						<v-file-input v-model="files" style="height:20px; margin-top:-20px;"
							placeholder="Adicionar Arquivo" flat :prepend-icon="'mdi-plus'" @change="newFile"
							color="#F15A24">
						</v-file-input>
					</div>
					<VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
						:editor-toolbar="customToolbar" v-model="annotation.texto" />
				</v-card-text>
				<v-card-actions class="justify-end px-0">
					<v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
					<v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
						<v-icon class="ml-1" small>mdi-content-save</v-icon>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
a {
	text-decoration: none;
	color: black !important;
}

a:hover {
	color: #f15a24;
}

h2 {
	font-family: 'Inter';
	font-weight: bold;
	color: #707070;
	text-align: left;
}

.filesButton {
	text-decoration: none !important;
}

.annotation {
	border: 1px solid rgb(200 200 200) !important;
	margin: 8px 0px;
	border-radius: 10px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
	max-width: 100% !important;
}

.annotation ::v-deep iframe {
	height: 250px;
}

.annotationText div {
	width: 100%;
}

.reg {
	border: 1px dashed gray;
	border-radius: 10px;
	padding: 5px;
}

/* Estilos para o grupo específico */
:deep(.v-tabs__bar) {
	background-color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-tabs__item--active) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-tabs__item:hover) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-btn--icon) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-icon) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-btn--text) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-btn--text:hover) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}
</style>

<script>
import BtnAdicionarGrupo from '../components/BtnAdicionarGrupo.vue';
import DialogConfirm from '../components/DialogConfirm.vue';
import Annotation from '../components/Annotation.vue';
import AnnotationProjetolei from '../components/AnnotationProjetolei.vue';
import { VueEditor } from 'vue2-editor';

export default {
	components: { BtnAdicionarGrupo, Annotation, DialogConfirm, VueEditor, AnnotationProjetolei },
	data: () => ({
		edit: {},
		showEditGroup: false,
		showGroupDetails: false,
		showNewAnnotation: false,
		active: "feed",
		loadingEdit: false,
		grupo: { administradores: [] },
		anotacoes: [],
		anotacoesProjetos: [],
		loadingFeed: false,
		integrantes: [],
		loadingNewAnnotation: false,
		annotation: {
			texto: '',
			id_grupo: null
		},
		files: null,
		statusAnnotation: [
			{ text: 'Público', value: 'published' },
			{ text: 'Grupo', value: 'group' },
			{ text: 'Privado', value: 'private' },
			{ text: 'Apenas Amigos', value: 'friend' },
			{ text: 'Arquivado', value: 'archived' },
		],
		customToolbar: [
			[{ font: [] }, { size: [] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ color: [] }, { background: [] }],
			// [{ script: "super" }, { script: "sub" }],
			[{ header: '1' }, { header: '2' }, 'blockquote', 'code-block'],

			[
				{ list: 'ordered' },
				{ list: 'bullet' },
				{ indent: '-1' },
				{ indent: '+1' },
			],
			['direction', { align: [] }],
			['link', 'image', 'video'],
			['clean'],
		],
	}),
	mounted() {
		this.reloadGrupo();
	},
	computed: {
		groups() {
			return this.$store.state.filteredGroups;
		},
		isAdmin() {
			// return false
			return this.grupo.administradores.find(
				(e) => e.directus_users_id.id === this.$store.state.user.id
			);
		},
		isOwner() {
			return this.grupo.user_created === this.$store.state.user.id;
		},
		user() {
			return this.$store.state.user;
		},
		dynamicColor() {
			return this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f' ? '#d8934e !important' : '#F15A24';
		}
	},
	methods: {
		async updateGroup() {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				nome_grupo: this.edit.nome_grupo,
			});
			this.edit = {};
			this.loadingEdit = false;
			this.showEditGroup = false;
			this.reloadGrupo();
		},
		isInAdmin(id) {
			let eh = this.grupo.administradores.find(
				(e) => e.directus_users_id.id === id
			);
			return eh !== undefined;
		},
		async excluirGrupo() {
			if (!this.isOwner) {
				let integrante = this.grupo.integrantes.filter(
					(e) => e.directus_users_id.id === this.user.id
				);
				this.excluirIntegrante(integrante[0].id, true);
				return;
			}
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				status: 'archived',
			});
			this.$router.go(-1);
		},
		async tornarAdmin(id) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				administradores: {
					create: [
						{
							directus_users_id: { id: id },
							grupos_id: this.$route.params.id_grupo,
						},
					],
				},
			});
			this.reloadGrupo();
		},
		async excluirAdmin(id) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				administradores: { delete: [id] },
			});
			this.reloadGrupo();
		},
		async excluirIntegrante(id, admin) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				integrantes: { delete: [id] },
			});
			this.reloadGrupo();

			if (admin) this.$router.go(-1);
		},
		reloadGrupo() {
			this.$http
				.get(
					'items/grupos/' +
					this.$route.params.id_grupo +
					'?fields=integrantes.*,administradores.*,administradores.directus_users_id.*,integrantes.directus_users_id.*,*'
				)
				.then((res) => {
					this.grupo = res.data.data;
					if (this.grupo.adminsitradores) {
						this.integrantes = this.grupo.integrantes.filter(
							(el) =>
								!this.grupo.administradores.find(
									(e) => e.directus_users_id.id === el.directus_users_id.id
								)
						);
					} else this.integrantes = this.grupo.integrantes;
					this.loadGroupsFeed();
					this.loadGroupsFeedProjetoLei();
				});
		},
		async loadGroupsFeed() {
			this.loadingFeed = true;
			this.anotacoes = [];
			const query = `query MyGroup($group_id:String){
			anotacoes(
				filter: {  id_grupo: { id: { _eq: $group_id}}, status: { _neq: "archived" }}
			) {
				id
				texto
				date_created
				likes { 
					id 
					first_name
				}
				date_updated
				status
				user_created {
					first_name
					last_name
					id
					avatar { 
						id 
					}
				}
				id_lei {
					id_lei
					numero_lei
				}
				id_reg { 
					id_reg
					conteudo
				}
				id_grupo { 
					id
					nome_grupo
				}  
			}
				}`;
			const variables = {
				group_id: this.grupo.id,
			};
			const {
				data: { data },
			} = await this.$http.post('/graphql', {
				query,
				variables,
			});
			this.anotacoes = this.anotacoes.concat(data.anotacoes);
			this.anotacoes.sort(
				(a, b) => new Date(b.date_created) - new Date(a.date_created)
			);
			this.loadingFeed = false;
		},
		async loadGroupsFeedProjetoLei() {
			this.anotacoesProjetos = [];
			try {
				const query = `query MyGroup($group_id:String){
				projetos_leis_anotacoes(
					filter: {  grupo: { id: { _eq: $group_id}}, status: { _neq: "archived" }}
				) {
					id
					texto
					date_created
					likes { 
						id 
					}
					comentarios { 
						id
						user_created { 
							id
							first_name
							avatar { 
								id
							}
						}
						message
					}
					date_updated
					status
					user_created {
						first_name
						last_name
						id
						avatar { 
							id 
						}
					}
					projeto_lei {
						numero
					}
				
					grupo { 
						id
						nome_grupo
					}  
		
				}
					}`;
				const variables = {
					group_id: this.grupo.id,
				};
				const {
					data: { data },
				} = await this.$http.post('/graphql', {
					query,
					variables,
				});
				
				if (data && data.projetos_leis_anotacoes) {
					this.anotacoesProjetos = this.anotacoesProjetos.concat(data.projetos_leis_anotacoes);
					this.anotacoesProjetos.sort(
						(a, b) => new Date(b.date_created) - new Date(a.date_created)
					);
				}
			} catch (error) {
				window.console.error('Erro ao carregar anotações de projetos de lei:', error);
			}
		},
		handleImageAdded(file, Editor, cursorLocation) {
			// window.console.log(file);
			const formData = new FormData();
			formData.append('image', file);
			this.$http
				.post('/files', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((response) => {
					// window.console.log(response);
					let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
					Editor.insertEmbed(cursorLocation, 'image', url);
				})
				.catch((err) => {
					window.console.log(err);
				});
		},
		async saveNewAnnotation() {
			this.loadingNewAnnotation = true;
			try {
				const response = await this.$http.post('items/anotacoes', {
					texto: this.annotation.texto,
					status: 'group',
					id_grupo: this.grupo.id
				});

				if (response.data.data.id) {
					this.showNewAnnotation = false;
					this.annotation.texto = '';
					this.loadGroupsFeed();
					this.loadGroupsFeedProjetoLei();
				}
			} catch (error) {
				window.console.error('Erro ao salvar anotação:', error);
			} finally {
				this.loadingNewAnnotation = false;
			}
		},
		newFile(file) {
			if (!file) return;
			const formData = new FormData();
			formData.append('file', file);
			this.$http.post('/files', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(response => {
				const url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
				this.$refs.editor.quill.insertEmbed(this.$refs.editor.quill.getSelection().index, 'image', url);
			});
		},
		undo() {
			this.$refs.editor.quill.history.undo();
		},
		redo() {
			this.$refs.editor.quill.history.redo();
		},
		sanitizeTitle: function (title) {
			var slug = '';
			// Change to lower case
			var titleLower = title.toLowerCase();
			// Letter "e"
			slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
			// Letter "a"
			slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
			// Letter "o"
			slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
			// Letter "u"
			slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
			// Letter "d"
			slug = slug.replace(/đ/gi, 'd');
			// Trim the last whitespace
			slug = slug.replace(/\s*$/g, '');
			// Change whitespace to "-"
			slug = slug.replace(/\s+/g, '-');
			return slug;
		},
	},
};
</script>
